"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Display (and optionally queue) dialogs
 *
 * Show messages to the user and optionally pass buttons width callbacks.
 * If no buttons are passed an ok-button is added.
 * If a button doesn't have a callback function it just closes the dialog.
 */
var Dialog = /** @class */ (function () {
    function Dialog($sce, appState) {
        this.$sce = $sce;
        this.appState = appState;
        this.queue = [];
    }
    /**
     * @description Adds a dialog to the queue and triggers first dialog in queue to be shown
     *
     * @param {string} message
     * @param {Object} [options]
     * @param {string} [options.title]
     * @param {string} [options.type = 'alert']
     * @param {Object[]} [options.buttons = Object[] | false]
     * @param {string} [options.buttons[].label = 'Ok']
     * @param {Function} [options.buttons[].callback]
     * @param {boolean} [options.buttons[].keep]
     */
    Dialog.prototype.show = function (message, options) {
        message = this.$sce.trustAsHtml(message);
        var defaults = {
            message: message,
            buttons: [{ label: 'OK', style: 'primary' }],
            type: 'alert'
        };
        var dialog = Object.assign(defaults, options);
        this.queue.push(dialog);
        this.showNextDialog();
    };
    /**
     * Shows first dialog from queue if no other is already displayed
     */
    Dialog.prototype.showNextDialog = function () {
        if (this.current || !this.queue.length) {
            return;
        }
        this.current = this.queue[0];
        this.appState.appCtrl.showFullPreview(false);
    };
    /**
     * Hides the current dialog and triggers next
     *
     * @param {Function} [callback]
     */
    Dialog.prototype.closeDialog = function () {
        delete this.current;
        this.queue.shift();
        this.showNextDialog();
    };
    return Dialog;
}());
exports.Dialog = Dialog;
function DialogsDirective(config, dialog) {
    return {
        templateUrl: config.params.base + "templates/book/dialog.html",
        scope: true,
        controller: /** @class */ (function () {
            function DialogsController() {
            }
            Object.defineProperty(DialogsController.prototype, "current", {
                get: function () {
                    return dialog.current;
                },
                enumerable: true,
                configurable: true
            });
            Object.defineProperty(DialogsController.prototype, "queue", {
                get: function () {
                    return dialog.queue;
                },
                enumerable: true,
                configurable: true
            });
            DialogsController.prototype.onClick = function (callback, keep) {
                if (keep === void 0) { keep = false; }
                if (callback) {
                    callback();
                }
                if (!keep) {
                    dialog.closeDialog();
                }
            };
            return DialogsController;
        }()),
        controllerAs: 'dialogs'
    };
}
function DialogDirective($compile, $timeout) {
    return {
        scope: {
            dialog: '='
        },
        controller: /** @class */ (function () {
            function DialogController() {
                this.success = null;
            }
            DialogController.prototype.onSuccess = function (e) {
                var _this = this;
                e.clearSelection();
                this.success = null;
                $timeout(function () {
                    _this.success = true;
                });
            };
            DialogController.prototype.onError = function (e) {
                var _this = this;
                this.success = null;
                $timeout(function () {
                    _this.success = false;
                });
            };
            return DialogController;
        }()),
        link: function (scope, element) {
            element.prepend($compile("\n        <div class=\"pb-dialog-title\" ng-if=\"dialog.title\">" + scope.dialog.title + "</div>\n        <div class=\"pb-dialog-message\">" + scope.dialog.message + "</div>")(scope));
        },
        controllerAs: 'dialogCtrl'
    };
}
exports.default = angular.module('pb.dialog', [])
    .service('dialog', Dialog)
    .directive('pbDialogs', DialogsDirective)
    .directive('pbDialog', DialogDirective);
